var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.componentName)?_c(_vm.componentName,{tag:"component",attrs:{"activityId":_vm.activityId,"isVip":_vm.isVip}}):_c('AppLoading',{staticClass:"app-loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }